// #reigon for scrollbar

// ✅ Test 1 basic test without filter/freeze
// ✅ Test 1- Test with hidden without filter/freeze
// ✅ Test 2 test with freeze
// ✅ Test with hidden within freeze / after freeze
// ✅ Test with hidden b/w freeze and non freeze
// ✅ Test with filter
// ✅ Test with filter and hidden(hidden rows cannot be part of filter)
// ✅ Test with filter and freeze (filter b/w freeze and nonFreeze)
// ✅ Test with filter and freeze (filter after freeze)
// ✅ Test with freeze way above than filter.lastRow

import { FilterResults, Sheet } from '../../types';
import { HeaderGroup } from '../../types/sheet/headerGroups';

const test1Filter: FilterResults = {
  startRow: -1,
  hasFilter: false,
  rowsIndexes: [],
  filterIndexesMap: {},
  lastRow: -1,
};

const colGroups: HeaderGroup[] = [
  {
    id: '1-col',
    start: 0,
    end: 2,
    color: 'pink',
    name: 'Athelete Name',
    nestedGroups: [
      // {
      //   id: '1-col-1',
      //   start: 0,
      //   end: 1,
      //   color: 'red',
      //   name: 'Athelete Name',
      //   nestedGroups: []
      // }
    ],
  },
  {
    id: '2-col',
    start: 3,
    end: 5,
    color: 'orange',
    name: 'Sport',
    nestedGroups: [],
  },
];

const rowGroups: HeaderGroup[] = [
  {
    id: '1-row',
    start: 0,
    end: 5,
    color: 'pink',
    name: 'Athelete Name',
    nestedGroups: [],
  },
  {
    id: '2-row',
    start: 7,
    end: 10,
    color: 'orange',
    name: 'Sport',
    nestedGroups: [],
  },
];

const test1Set: Partial<Sheet> = {
  colGroups,
  rowGroups,
  //   hiddenRows: [
  //     {
  //       start: 4,
  //       end: 6,
  //     },
  //     {
  //       start: 10,
  //       end: 19,
  //     },
  //   ],
  // freezedRows: {
  //   frozen: true,
  //   start: 2,
  //   end: 10,
  // },
  // freezedCols: {
  //   frozen: true,
  //   start: 2,
  //   end: 2,
  // },
  // merges: [
  //   {
  //     start: {
  //       ci: 2,
  //       ri: 5
  //     },
  //     end: {
  //       ci: 3,
  //       ri: 8
  //     }
  //   }
  // ]
};
// #endregion

export const testFilterResults = test1Filter;
export const testPartialSheet = test1Set;
